module.exports = __webpack_public_path__ + "img/Flag.680e245c.png";